module.exports = __webpack_public_path__ + "static/media/viva_vertical_logo.c9a91164.png";